(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-founder-story-recommendations"]) return;
  try {
    
  (() => {
    const initFounderVideo = (root = document) => {
      root.querySelectorAll('[data-pm-video-player]').forEach((player) => {
        if (player.dataset.pmVideoReady === 'true') return;

        const video = player.querySelector('video');
        const button = player.querySelector('[data-pm-video-play]');
        if (!video || !button) return;

        player.dataset.pmVideoReady = 'true';
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;

        const prepareVideo = () => {
          let hasDeferredSource = false;

          video.querySelectorAll('source[data-src]').forEach((source) => {
            if (!source.hasAttribute('src')) {
              source.setAttribute('src', source.dataset.src);
              hasDeferredSource = true;
            }
          });

          if (hasDeferredSource) video.load();
          video.controls = true;
        };

        const playVideo = () => {
          prepareVideo();
          const playPromise = video.play();
          if (playPromise) {
            playPromise
              .then(() => {
                button.hidden = true;
              })
              .catch(() => {
                button.hidden = false;
                button.disabled = false;
              });
          } else {
            button.hidden = true;
          }
        };

        button.addEventListener('click', () => {
          button.disabled = true;
          playVideo();
        });

        video.addEventListener('play', () => {
          button.hidden = true;
        });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  playVideo();
                } else if (!video.paused) {
                  video.pause();
                }
              });
            },
            {
              rootMargin: '200px 0px',
              threshold: 0.15,
            }
          );

          observer.observe(player);
        } else {
          playVideo();
        }
      });
    };

    initFounderVideo();
    document.addEventListener('shopify:section:load', (event) => initFounderVideo(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-founder-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFounderVideo = (root = document) => {
      root.querySelectorAll('[data-pm-video-player]').forEach((player) => {
        if (player.dataset.pmVideoReady === 'true') return;

        const video = player.querySelector('video');
        const button = player.querySelector('[data-pm-video-play]');
        if (!video || !button) return;

        player.dataset.pmVideoReady = 'true';
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;

        const prepareVideo = () => {
          let hasDeferredSource = false;

          video.querySelectorAll('source[data-src]').forEach((source) => {
            if (!source.hasAttribute('src')) {
              source.setAttribute('src', source.dataset.src);
              hasDeferredSource = true;
            }
          });

          if (hasDeferredSource) video.load();
          video.controls = true;
        };

        const playVideo = () => {
          prepareVideo();
          const playPromise = video.play();
          if (playPromise) {
            playPromise
              .then(() => {
                button.hidden = true;
              })
              .catch(() => {
                button.hidden = false;
                button.disabled = false;
              });
          } else {
            button.hidden = true;
          }
        };

        button.addEventListener('click', () => {
          button.disabled = true;
          playVideo();
        });

        video.addEventListener('play', () => {
          button.hidden = true;
        });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  playVideo();
                } else if (!video.paused) {
                  video.pause();
                }
              });
            },
            {
              rootMargin: '200px 0px',
              threshold: 0.15,
            }
          );

          observer.observe(player);
        } else {
          playVideo();
        }
      });
    };

    initFounderVideo();
    document.addEventListener('shopify:section:load', (event) => initFounderVideo(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-story-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initStoryVideos = (root = document) => {
      root.querySelectorAll('[data-pm-video-player]').forEach((player) => {
        if (player.dataset.pmVideoReady === 'true') return;

        const video = player.querySelector('video');
        const button = player.querySelector('[data-pm-video-play]');
        if (!video || !button) return;

        player.dataset.pmVideoReady = 'true';
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;

        const prepareVideo = () => {
          let hasDeferredSource = false;

          video.querySelectorAll('source[data-src]').forEach((source) => {
            if (!source.hasAttribute('src')) {
              source.setAttribute('src', source.dataset.src);
              hasDeferredSource = true;
            }
          });

          if (hasDeferredSource) video.load();
          video.controls = true;
        };

        const playVideo = () => {
          prepareVideo();
          const playPromise = video.play();
          if (playPromise) {
            playPromise
              .then(() => {
                button.hidden = true;
              })
              .catch(() => {
                button.hidden = false;
                button.disabled = false;
              });
          } else {
            button.hidden = true;
          }
        };

        button.addEventListener('click', () => {
          button.disabled = true;
          playVideo();
        });

        video.addEventListener('play', () => {
          button.hidden = true;
        });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  playVideo();
                } else if (!video.paused) {
                  video.pause();
                }
              });
            },
            {
              rootMargin: '200px 0px',
              threshold: 0.15,
            }
          );

          observer.observe(player);
        } else {
          playVideo();
        }
      });
    };

    initStoryVideos();
    document.addEventListener('shopify:section:load', (event) => initStoryVideos(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
